module.exports = __webpack_public_path__ + "media/images/minshi-card-63eade8ff5e7be35327a225f5b42ee67.png";